{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Seleccionar un artículo",
  "tableResizer": "Cambiador de tamaño",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
